import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'projects/kesher-site/src/environments/environment';
import { AdvMessageService, CaptchVersion, CommonService, LocalizationService, LoginMode, LoginStatus, verificationCodeModel, VerificationType } from 'projects/shared/src/public-api';
import { AppAuthService } from '../../../kesher-shared/services/app-auth.service';
import { LoginModel } from '../../model/login.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  //encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  siteKeyV2: string = '6LePTxoaAAAAAD8T2Bdm7g-DSphQrzS2whX43adC';

  constructor(
    private _localizationService: LocalizationService,
    private _appAuthService: AppAuthService,
    private messagesService: AdvMessageService,
    private router: Router,
    private route: ActivatedRoute,
    private _cdr: ChangeDetectorRef,
    private recaptchaV3Service: ReCaptchaV3Service,
    private commonService: CommonService) {

  }
  //#region Private Members
  private pageName: string = "LoginComponent";
  //#endregion

  //#region Public Members
  @ViewChild("form") form: NgForm;
  @ViewChild("loginDetails") loginDetails: ElementRef;
  @ViewChild("loginTemplate") loginTemplate: any;
  @ViewChild("newUserTemplate") newUserTemplate: any;
  @ViewChild("verficationTemplate") verficationTemplate: any;
  @ViewChild("changePasswordTemplate") changePasswordTemplate: any;
  @ViewChild("newUser") newUser: any;
  @ViewChild("loginPanel") loginPanel: any;
  @ViewChild("codeVerify") codeVerify: any;
  @ViewChild("changePasswordPanel") changePasswordPanel: any;

  loginModel: any = new LoginModel();
  mode: LoginMode = LoginMode.Login;
  loginMode = LoginMode;
  disableLoginButton: boolean;
  showPass: boolean;
  error: string;
  verificationCodeDetails: verificationCodeModel;
  verificationRequired: boolean;
  loginBlocked: boolean = false;
  templates: any;
  LoginMode = LoginMode;
  version: string = environment.version;
  isMobile: boolean = window.innerWidth > 1280 ? false : true;

  //#endregion

  //#region Angular lifecycle Methods
  ngOnInit(): void {

    this.loginModel.userMailOrPhone = this._appAuthService.userMailOrPhone;
    this.loginModel.clientVersion = environment.version;
    this.route.queryParams.subscribe(params => {
      if (params.token)
        this.mode = LoginMode.New;
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      var captchaElement: any = document.querySelector('.grecaptcha-badge');
      if (captchaElement)
        captchaElement.style.visibility = 'visible';
    }, 100);

    this.templates = {
      Login: this.loginTemplate,
      New: this.newUserTemplate,
      Forgot: this.verficationTemplate,
      Verify: this.verficationTemplate,
      Change: this.changePasswordTemplate
    }
  }
  //#endregion

  //#region Event Methods
  // onVerificationCodeCancel() {
  //   this.verificationCodeDetails.verificationCodeSend = false;
  //   this.back();
  // }

  onMailVerficationClicked() {
    this.loginModel.verificationType = VerificationType.Mail;
    this.disableLoginButton = false;
    this.loginProcess();
  }
  loginClicked() {
    if (!this.form.valid) {
      return;
    }
    this.loginProcess()
  }

  changeView(mode: LoginMode) {
    this.mode = mode;
    this._cdr.markForCheck();
  }

  sendAgainVerificationCode(verificationType: VerificationType) {
    this.loginModel.verificationType = verificationType;
    this.loginModel.verificationCode = null;
    if (this.mode == LoginMode.Verify)
      this.loginProcess();
    else if (this.mode == LoginMode.Forgot) // TODO check what about Change mode
      this.sendRecoverPasswordVerification();

  }

  verificationCodeSent(event) {
    this.loginModel.password = event.password;
    this.loginModel.userMailOrPhone = event.mail;
    this.loginModel.verificationType = VerificationType.Mail;
    this.verificationCodeDetails = {
      verificationCodeSend: true,
      encryptedNumMailOrPhone: event.encryptedNumMailOrPhone,
      verificationType: this.loginModel.verificationType
    };
    this.changeView(LoginMode.Verify);
  }

  onVerificationCodeChange(event) {
    this.loginModel.verificationCode = event;
    if (this.mode == LoginMode.Forgot)
      this.verifyRecoverPasswordCode();
    else
      this.loginProcess();
  }

  loginFromNewPassword(event: any) {
    this.loginModel.verificationCode = null;
    this.loginModel.verificationType = null;
    this.loginModel.password = event;
    this.loginProcess();
  }

  loginProcess() {
    this.error = null;
    this.recaptchaV3Service.execute('login')
      .subscribe((token: string) => {
        this.loginModel.captchaToken = token;
        this.loginModel.captchVersion = CaptchVersion.V3;
        this.login();
        this._cdr.markForCheck();
      });

  }

  login() {
    this._appAuthService.login(this.loginModel).subscribe(response => {
      let errorMessage = null;
      switch (response.status) {
        case LoginStatus.Succeeded:
          this.navigate(response.companyCode || this._appAuthService.company?.companyCode, response.isClientVersionNotUpdated);
          break;
        case LoginStatus.InvalidLogin:
          errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.INVALID_LOGIN");
          break;
        case LoginStatus.BlockedSystem:
          errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.BLOCKED_SYSTEM");
          this.loginBlocked = true;
          break;
        case LoginStatus.RequiredVerification:
          if (this.loginModel.captchVersion == CaptchVersion.V3) {
            this.verificationRequired = true;
            errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.VERIFICATION_CODE_REQUIRED");
            this._cdr.markForCheck();
          }
          else {
            errorMessage = "אימות נכשל";
          }
          this.disableLoginButton = true;
          break;
        case LoginStatus.VerificationCodeSent:
          this.loginModel.verificationType = this.loginModel.verificationType ? this.loginModel.verificationType : VerificationType.Phone
          this.verificationCodeDetails = {
            verificationCodeSend: true,
            encryptedNumMailOrPhone: response.encryptedNumMailOrPhone,
            verificationType: this.loginModel.verificationType
          };
          this.changeView(LoginMode.Verify);
          break;
        case LoginStatus.InvalidVerificationCode:
          errorMessage = this._localizationService.Translate("LOGIN.MESSAGES.INVALID_VERIFICATION_CODE");
          break;

        default:
          errorMessage = this._localizationService.Translate("ERROR_MESSAGES.UNKNOWN_ERROR");
          break;
      }
      if (errorMessage) {
        this.messagesService.errorMessage(errorMessage, 2000);
      }
    })
  }
  getTemplate() {
    return this.templates?.[this.loginMode[this.mode]];
  }
  back() {
    this.clear();
    this.changeView(LoginMode.Login);
  }

  handleClick(event: LoginMode) {
    switch (event) {
      case LoginMode.Login:
        this.loginPanel.submitForm();
        break;

      case LoginMode.New:
        this.startRegistration();
        break;

      case LoginMode.Verify:
        this.codeVerify.okClicked();
        break;

      case LoginMode.Forgot:
        //this.verifyRecoverPasswordCode();
        this.codeVerify.okClicked();
        break;

      case LoginMode.Change:
        this.changePasswordPanel.changePassword();
        break;
    }
  }

  startRegistration() {
    this.newUser.startRegistration();
  }

  sendRecoverPasswordVerification() {
    //if its first time of forot password - check if mail or tel are valid, 
    //but if its "send again" method, dont check again the phone (in this case, login panel is undefined)
    if (!this.loginPanel || this.loginPanel.validMailOrTel()) {

      this.recaptchaV3Service.execute('sendRecoverPasswordVerification')
        .subscribe((token: string) => {
          this.loginModel.captchaToken = token;
          this._appAuthService.sendRecoverPasswordVerification(this.loginModel).subscribe(res => {
            if (res.status == LoginStatus.VerificationCodeSent) {
              this.loginModel.verificationType = this.loginModel.userMailOrPhone?.indexOf('@') > 1 ? VerificationType.Mail : VerificationType.Phone;
              this.verificationCodeDetails = {
                verificationCodeSend: true,
                encryptedNumMailOrPhone: res.encryptedNumMailOrPhone,
                verificationType: this.loginModel.verificationType
              };
              this.changeView(LoginMode.Forgot);
            }
            else {
              if (res.status == LoginStatus.BlockedSystem) {
                this.messagesService.errorMessage("המערכת ננעלה למספר רגעים, נסה שנית מאוחר יותר");
              }
              if (res.status == LoginStatus.UserNotExists) {
                this.messagesService.errorMessage("פרטי התחברות שגויים");
              }
            }
          });
        });
    }
  }

  verifyRecoverPasswordCode() {
    this.error = null;
    this.recaptchaV3Service.execute('verifyRecoverPasswordCode')
      .subscribe((token: string) => {
        this.loginModel.captchaToken = token;
        this.loginModel.captchVersion = CaptchVersion.V3;
        this._appAuthService.verifyRecoverPasswordCode(this.loginModel).subscribe(res => {
          if (res.status == LoginStatus.Succeeded) {
            this.changeView(LoginMode.Change);
          }
          else {
            if(res.status == LoginStatus.RequiredVerification)
            this.messagesService.errorMessage("שגיאת אבטחה");
            else if(res.status == LoginStatus.InvalidVerificationCode)
            this.messagesService.errorMessage("קוד האימות אינו תקין");
          }
        })       
      });
  }
  //#endregion

  //#region Private Methods
  private clear() {
    this.verificationCodeDetails = null;
    if (this.loginMode) {
      this.loginModel.verificationCode = null;
      this.loginModel.verificationType = null;
    }
    this.error = null;
    this.clearScreen();
  }
  private clearScreen() {
    this.loginModel.userMailOrPhone = null;
    this.loginModel.password = null;
  }
  private navigate(companyCode: string, isClientVersionNotUpdated: boolean) {
    const returnUrl = this.route.snapshot.queryParams.returnUrl;
    if (returnUrl) {
      this.router.navigate([returnUrl]);
    } else if (companyCode) {
      this.router.navigate([`kesher/${companyCode}/home`]);
    } else {
      this.router.navigate([`personal`]);
    }

    setTimeout(() => {
      //the client version is not updated, ask if want to refresh
      if (isClientVersionNotUpdated) {
        this.commonService.updateNewVersion();

        // this.messagesService.showConfirmation(this._localizationService.Translate("LOGIN.UPDATE_VERSION_TITLE"),
        //   this._localizationService.Translate("LOGIN.UPDATE_VERSION_MESSAGE"),
        //   () => {
        //     let c = window.location; 
        //     (c as any).reload(true);
        //     //window.location.reload();
        //   }, () => { }, "המשך", null, false);
      }
    }, 300);


  }
  getLabel() {
    switch (this.mode) {
      case LoginMode.Login:
        return 'LOGIN.LOGIN_TITLE';

      case LoginMode.New:
        return 'LOGIN.NEW_USER';

      case LoginMode.Forgot:
        return 'LOGIN.FORGOT_PASSWORD';

      case LoginMode.Verify:
        return 'LOGIN.VERIFICATIN_TITEL';

      case LoginMode.Change:
        return 'LOGIN.CHANGE_PASSWORD';

      default:
        return '';
    }
  }

  openGmailChat() {
    const email = 'kesherhk@gmail.com'; // כתובת האימייל שאליה רוצים לשלוח הודעה
    const chatUrl = `https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=${email}`;
    window.open(chatUrl, '_blank');
  }
  //#endregion

  onRecaptchaV2Resolved(token: string) {
    this.loginModel.captchaToken = token;
    this.loginModel.captchVersion = CaptchVersion.V2;
    this.login();
  }
}
